import { render, staticRenderFns } from "./ExtensionsPermissionGuard.vue?vue&type=template&id=02f89aa0&scoped=true&"
import script from "./ExtensionsPermissionGuard.vue?vue&type=script&lang=js&"
export * from "./ExtensionsPermissionGuard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f89aa0",
  null
  
)

export default component.exports